/**
 * @ngdoc service
 * @name User
 * @description
 * @param $http
 * @param $q
 * @param environment
 * @constructor
 * @param $rootScope
 * @param $exceptionService
 */
export default function User($http, $q, environment, $rootScope, $exceptionService) {
  'ngInject';
  //Static Vars
  const storageName = `user${environment.name}`;

  //Internal vars
  let storageUser,
    currentUser;

  //Check if the user is in local storage
  storageUser = window.localStorage.getItem(storageName);
  //If so jsonify the string and set the internal variable to reflect
  currentUser = storageUser ? angular.fromJson(storageUser) : undefined;

  //Private Functions
  /**
   * @name setUser
   * @description Set internal state and set persistent state;
   * @param data
   */
  let setUser = (data) => {
    $rootScope.$applyAsync(function () {
      currentUser = data;
      $exceptionService.setUserContext({
        email: currentUser.email,
        id: currentUser.id
      });
    });
    window.localStorage.setItem(storageName, angular.toJson(data));
  };

  /**
   * @name clearUser
   * @description Clear user state.
   */
  let clearUser = () => {
    $rootScope.$applyAsync(function () {
      currentUser = undefined;
    });
    window.localStorage.removeItem(storageName);
  };

  /**
   * @name currentUser
   * @description Bindable currentUser
   */
  Object.defineProperty(this, 'currentUser', {
    get: function () {
      return currentUser;
    }
  });

  /**
   * @name loggedIn
   * @description Non promise based way to get the current login status.
   * @returns {object} the user object | null
   */
  this.loggedIn = () => {
    return currentUser !== undefined;
  };

  //Public Functions
  /**
   * @name authenticate
   * @description Authenticates the credentials with the backend.
   * @param username
   * @param password
   */
  this.authenticate = (username, password) => {

    if (!username || !password) {
      $q.reject();
    }


    let defer = $q.defer();

    const url = `${environment.api.baseUrl}/users/authenticate/`,
      params = {
        url: url,
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        data: {
          username: username,
          password: password
        }
      };

    let req = $http(params),

      success = (user) => {
        setUser(user.data);
        defer.resolve(currentUser);
      },

      error = (error) => {
        clearUser();
        defer.reject(error.data);
      };

    req.then(
      success,
      error
    );

    return defer.promise;
  };

  /**
   * @name getUser
   * @description Provides the current user or null if not logged-in
   */
  this.getUser = () => {
    //Defer request
    let defer = $q.defer();

    //Setup request
    //Using with credentials true, we will send the request to the server with the user cookie in place already
    const userUrl = `${environment.api.baseUrl}/users/show/`,
      params = {
        method: 'GET',
        url: userUrl,
        cache: true
      };

    //Then actions
    let req = $http(params),
    //Successful request will return our user POJO
      success = (response) => {
        setUser(response.data);
        defer.resolve(currentUser);
      },
    //Unsuccessful means that the token is invalid
      error = (response) => {
        if (response.status === 403) {
          clearUser();
          defer.resolve(undefined);
        }
        else {
          clearUser();
          defer.reject();
        }
      };

    req
      .then(
      success,
      error
    );
    return defer.promise;
  };

  this.resetPassword = (email) => {
    let defer = $q.defer();

    const url = `${environment.api.baseUrl}/users/resetPassword/`,
      params = {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        data: {
          email
        },
        url: url
      };

    let req = $http(params);

    req.then(
      (response)=> {
        if (response.data.result) defer.resolve();
        else defer.reject(response.data.error);
      },
      (response)=> {
        defer.reject(response.data.error);
      });

    return defer.promise;
  };

  /**
   * @name Exists
   * @description Checks server for existing key on the users resource. Rejects promise if the user exists, resolves if the user does not exist. Use then and catch
   * @param key
   */
  this.exists = (key) => {
    let defer = $q.defer();

    const url = `${environment.api.baseUrl}/users/exists/`,
      params = {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        data: {
          key
        },
        url: url,
        cache: true
      };

    let req = $http(params);

    req.then((response)=> {
      if (response.data.unique) defer.resolve(response.data);
      else defer.reject(response.data);
    });

    return defer.promise;
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/services/user/user.service.js
 **/